import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { LayoutPlugin, CollapsePlugin, FormInputPlugin, InputGroupPlugin, FormSelectPlugin, SpinnerPlugin, BIcon, BIconChevronUp, BIconChevronDown, BIconCheck, BIconBug } from 'bootstrap-vue'
import Vuex from 'vuex'
import VueClipboard from 'vue-clipboard2'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Honeybadger from 'honeybadger-js'
import { i18n } from './lang/index'
import './assets/style.css'
import './assets/bootstrap-grid.min.css'

Honeybadger.configure({
    apiKey: '870b376e',
    environment: 'production'
})

Vue.use(Vuex)
Vue.config.productionTip = false
Vue.use(LayoutPlugin)
Vue.use(CollapsePlugin)
Vue.use(FormInputPlugin)
Vue.use(SpinnerPlugin)
Vue.use(FormSelectPlugin)
Vue.use(InputGroupPlugin)
Vue.component('BIcon', BIcon)
Vue.component('BIconChevronUp', BIconChevronUp)
Vue.component('BIconChevronDown', BIconChevronDown)
Vue.component('BIconCheck', BIconCheck)
Vue.component('BIconBug', BIconBug)
Vue.use(VueClipboard)
Vue.use(VueAxios, axios)
VueClipboard.config.autoSetContainer = true

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
